<template>
  <div class="animated fadeIn">
    <Forms ref="frmCategoria"
      :title="'CADASTRO DE CATEGORIA'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label><small v-if="form.nome.required" class="text-danger">*</small> Categoria:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome da Categoria'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>

      <NxSelectPA
        :multiple="false"
        v-model="form.paId.value"
        @update:value="handleSelectUpdate('paId', $event)"
      />

      <div class="form-group">
        <div class="col-md-12 padding-left">
          <label>Possui Subcategoria?</label>
          <b-form-radio-group v-model="form.standalone.value" class="d-flex" @change="handleStandaloneChange">
            <b-form-radio :value="false">Sim</b-form-radio>
            <b-form-radio :value="true">Não</b-form-radio>
          </b-form-radio-group>
        </div>
      </div>

      <div v-if="!form.standalone.value">
        <div class="form-group row" v-for="(nome, index) in formSubCategorias" :key="index + 'SubCategorias'">
          <div class="col-md-6 padding-top">
            <label><small v-show="nome.nome.required" class="text-danger">*</small> SubCategoria:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite uma Subcategoria'"
                            v-model="nome.nome.value"
                            :required="nome.nome.required"
                            :state="nome.nome.state"></b-form-input>
            </div>
          </div>
          <div class="col-md-1 mt-4">
            <i
              v-on:click="onDeleteSubCategorias(nome)"
              class="fa fa-trash text-danger icone-grid"
              v-b-tooltip.hover
              :title="'Clique para remover a subcategoria'"
            ></i>
          </div>
        </div>
        <div class="col-md-2 pt-3">
          <button type="button" class="btn btn-third btn-sm" v-on:click="onCreateNewSubForm()" v-b-tooltip.hover>
            <i class="fas fa-plus"></i> <span> Adicionar Subcategoria</span>
          </button>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import CategoriaModel from '@/shared/models/configurations/categoriamodel.js'
import SubCategoriaModel from '@/shared/models/configurations/subcategoriamodel.js'
import { NxSelectPA } from '@/components/nexum/components/custom-selects/index.js'

import CategoriaForms from './categoria-form.js'
import SubCategoriaForms from './subcategoria-form.js'

import CategoriaRepository from '@/shared/http/repositories/nxSenhas/categoria.js'
import SubCategoriaRepository from '@/shared/http/repositories/nxSenhas/subCategoria.js'

export default {
  name: 'CategoriaAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: CategoriaModel,
      form: CategoriaForms,
      formSubCategorias: [],
      dataSubCategorias: []
    }
  },
  components: {
    NxSelectPA
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {},
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.formSubCategorias = []

      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onEdit (obj) {
      loading.push()
      try {
        Tools.SetValueInForm(this.form, this.data, obj)

        this.formSubCategorias = []
        this.dataSubCategorias = []

        this.form.paId.value = obj.pa
          ? { id: obj.pa.id, text: obj.pa.descricao }
          : null

        if (obj.subcategoria && obj.subcategoria.length > 0) {
          obj.subcategoria.forEach(sub => {
            const newSubCategoriaForm = JSON.parse(JSON.stringify(SubCategoriaForms))
            Tools.SetValueInForm(newSubCategoriaForm, new SubCategoriaModel(), sub)
            this.formSubCategorias.push(newSubCategoriaForm)
            this.dataSubCategorias.push(sub)
          })
        }
      } catch (error) {
        console.error('Erro no método onEdit:', error)
        toast.error('Erro ao carregar os dados para edição.')
      } finally {
        loading.pop()
      }
    },
    async onCreate () {
      loading.push()

      if (this.setDataForRequest()) {
        try {
          const response = await CategoriaRepository.Create(this.data)
          const categoriaId = response.data.id
          console.log('categoriaId', categoriaId)

          if (this.formSubCategorias.length > 0) {
            const promises = this.formSubCategorias.map(sub => {
              return SubCategoriaRepository.Create({
                nome: sub.nome.value,
                categoriaFilaId: categoriaId
              })
            })

            await Promise.all(promises)
          }

          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        } catch (error) {
          this.onException(error)
        }
      }
    },
    setDataForRequest () {
      this.data.subcategorias = []
      return true
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)

      const subCategoriasAtualizadas = this.formSubCategorias.map(sub => {
        sub.inactive.value = this.form.standalone.value ? 1 : 0

        return {
          id: sub.id,
          nome: sub.nome.value,
          inactive: sub.inactive.value,
          categoriaFilaId: this.data.id
        }
      })

      const promises = subCategoriasAtualizadas.map(subCategoria => {
        if (subCategoria.id) {
          return SubCategoriaRepository.Update(subCategoria, subCategoria.id)
        }
        return Promise.resolve()
      })

      Promise.all(promises)
        .then(() => {
          this.data.subcategorias = subCategoriasAtualizadas
          return CategoriaRepository.Update(this.data, this.data.id)
        })
        .then(() => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(error => {
          loading.close()

          let message = 'Erro desconhecido ao atualizar'
          if (error && error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message
          } else if (error && error.message) {
            message = error.message
          }

          toast.error(message)
          this.onException(error)
        })
    },
    handleStandaloneChange () {
      if (this.form.standalone.value) {
        this.formSubCategorias.forEach(sub => {
          sub.inactive.value = 1
        })
      } else {
        this.formSubCategorias.forEach(sub => {
          sub.inactive.value = 0
        })
      }
    },
    onCreateNewSubForm () {
      const newSubCategoriaForm = JSON.parse(JSON.stringify(SubCategoriaForms))
      this.formSubCategorias.push(newSubCategoriaForm)
      this.dataSubCategorias.push(new SubCategoriaModel())
    },
    onDeleteSubCategorias (nome) {
      let indexOfDeletion = this.formSubCategorias.indexOf(nome)
      this.formSubCategorias.splice(indexOfDeletion, 1)
      this.dataSubCategorias.splice(indexOfDeletion, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/nxSenhas/categoria/components/add/categoriaAdd.vue